import { createFileRoute } from "@tanstack/react-router";
import { Dashboard } from "#app/widgets/dashboards/dashboard";
import { MY_WORK_WIDGETS } from "#app/widgets/dashboards/my-work-widgets";
import { WidgetsGate } from "#app/widgets/dashboards/widgets-gate";
import { useAppData } from "#app/lib/data";

/**
 * `/my-work` — the current user's personal widget view, member-scoped to issues
 * assigned to them (`{ kind: "member", memberId: currentUser.userId }`). It's the
 * member-scoped host of the shared {@link Dashboard}, run in MANAGED mode: a
 * fixed, curated catalog (`MY_WORK_WIDGETS`) the user only toggles on/off — not
 * a free add-any-widget board. Feature-flagged behind WIDGETS; redirects home
 * when off (the sidebar item is hidden in that case anyway).
 */
function MyWorkScreen() {
  const { workspace } = Route.useParams();
  const { currentUser } = useAppData();
  return (
    <WidgetsGate redirectTo={`/${workspace}`}>
      {currentUser?.userId ? (
        <Dashboard
          scope={{ kind: "member", memberId: currentUser.userId }}
          managedCatalog={MY_WORK_WIDGETS}
          title="My Work"
          pageSettings
        />
      ) : null}
    </WidgetsGate>
  );
}

export const Route = createFileRoute("/(app)/$workspace/my-work")({
  component: MyWorkScreen,
});
